import firebase from './firebaseBundle'

const sendPasswordResetEmail = async (email) => {
  await firebase.auth().sendPasswordResetEmail(email)
}

export default sendPasswordResetEmail
